export enum PaymentProcessor {
    SUMUP = 'SUMUP',
    STRIPE = 'STRIPE',
    ZETTLE = 'ZETTLE',
    PAX = 'PAX',
}
